import { Component } from 'ng-metadata/core';
import {SearchStateService} from "../../../search/searchState.service";

@Component({
    'selector': 'prm-offset-limit-notification',
    templateUrl: 'components/infra/widgets/alerts/offset-limit-notification.directive.html',
})
export class OffsetLimitNotificationDirective {
    private icon: any;

    constructor(
        private searchStateService: SearchStateService
    ) {
        this.icon = {
            type: 'svg',
            iconSet: 'primo-ui',
            icon: 'error-outline'
        };
    }

    get isVisible() {
        return this.searchStateService.isOffsetLimitNotificationVisible();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/offset-limit-notification.directive.ts